import React, { Suspense, useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { Bus, SiteConfigManager, useApplicationState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

const IFrameSportsbook = React.lazy(() => import('./IFrameSportsbook'));
const IFrameBetHistory = React.lazy(() => import('./IFrameBetHistory'));
const IFrameResultsSportsbook = React.lazy(() => import('./IFrameResultsSportsbook'));

import { ContactSupportTeam } from '@atlas/ui';

import './bus.repeater';

import { navigationTypes } from './constants';

const SuspenseComponent = Component =>
  function () {
    return (
      <Suspense fallback={<span style={{ display: 'none' }} />}>
        <Component />
      </Suspense>
    );
  };

export default function IFrameRoutes() {
  const { authenticated, loading } = useApplicationState();
  const navigationList = SiteConfigManager.getConfig('config.pages', []).filter(
    ({ isActive, type }) => isActive && navigationTypes[type],
  );

  const links = SiteConfigManager.getConfig('config.pages', []);
  const activePage = links.find(({ isActive, type }) => isActive && navigationTypes[type]);

  const location = useLocation();

  useEffect(() => {
    Bus.emit('router:change_location', location);
  }, [location.pathname, location.search, location.hash]);

  if (loading) return null;

  if (!navigationList.length) {
    return <ContactSupportTeam />;
  }

  return (
    <Switch>
      {authenticated && <Route path="/bet-history" render={SuspenseComponent(IFrameBetHistory)} />}
      {navigationList.map(({ path, type }) => (
        <Route
          key={path}
          path={path}
          render={
            type === COMPONENT_TYPES.RESULTS
              ? SuspenseComponent(IFrameResultsSportsbook)
              : SuspenseComponent(IFrameSportsbook)
          }
        />
      ))}

      {activePage && <Redirect to={`${activePage?.path}${location.search}`} />}
    </Switch>
  );
}
